module.exports = __webpack_public_path__ + "static/media/29DUNON11.99ec1a93.jpg";